var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NewDesignModal,{attrs:{"title":_setup.titleName}},[_c('div',{staticClass:"player-container"},[_c(_setup.DailyMotionPlayer,{staticClass:"player",attrs:{"clip":_setup.clip,"isBackdrop":false,"isActive":true,"playerId":"x10mxm"}}),(!_setup.isPremium)?_c(_setup.JWTVProFooter):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }